import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImportsModule } from "../../shared/imports.module";
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { CatalogosService } from '../../shared/services/catalogos.service';
import { TableHeader, UmasData, CalendarioPagoData, CodigoClase, CatalogoSATData, Usuario } from '../../shared/models';
import { FormularioCalendarioComponent } from './formulario-calendario/formulario-calendario.component';
import { FormularioSatComponent } from './formulario-sat/formulario-sat.component';
import { FormularioUmaComponent } from './formulario-uma/formulario-uma.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { finalize, Subject, takeUntil } from 'rxjs';
import { PerfilStore } from '../../shared/store/perfil.store';
import { Router } from '@angular/router';
@Component({
  selector: 'app-catalogos',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ImportsModule, 
    NzSelectModule, 
    NzTableModule,
    NzButtonModule,
    NzIconModule,
    NzEmptyModule,
    NzDatePickerModule,
    NzInputModule,
    NzInputNumberModule,
    NzTagModule,
    NzSwitchModule,
    NzCollapseModule,
    NzDividerModule,
    NzPopconfirmModule,
    FormularioCalendarioComponent,
    FormularioSatComponent,
    FormularioUmaComponent
  ],
  templateUrl: './catalogos.component.html',
  styleUrl: './catalogos.component.scss'
})
export class CatalogosComponent {

  selectedOption: string | null = 'umas';
  tableHeaders: TableHeader[] = [];
  tableData: any[] = [];
  loading :boolean = false;
  
  private expandedCodigosIds: Set<number> = new Set();
  
  private editingCodigoKey: string | null = null;
  editingCodigoData: Partial<CodigoClase> = {};
  user: Usuario | null = {};
  $onDestroy: Subject<void> = new Subject<void>();
  anio : number = new Date().getFullYear();

  constructor(private message: NzMessageService, private catalogosService: CatalogosService, private drawerService: NzDrawerService, private cdr: ChangeDetectorRef, private sessionStore: PerfilStore, private router: Router) {
  }

  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
      this.sessionStore.getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user:Usuario | null) => {
        this.user = user;
        if(this.user?.esAdmin){
          this.loadTableData();
        }
        else {
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.sessionStore.clearPerfil();
          this.router.navigate(['/']);
        }
      });
  }

  getPeridosAjustes(anioData: number) {
    let today = new Date();
    let MesEnero = new Date(today.getFullYear(), 0, 1);
    let MesFebrero = new Date(today.getFullYear(), 1, 15);
    return (today >= MesEnero && today <= MesFebrero) && (this.anio == anioData);
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  onSelectChange(value: string): void {
    this.selectedOption = value;
    this.loadTableData();
  }

  private loadTableData(): void {
    this.tableData = [];
    switch (this.selectedOption) {
      case 'umas':
        this.tableHeaders = [
          { field: 'fechaInicio', title: 'Fecha Inicio' },
          { field: 'fechaFin', title: 'Fecha Fin' },
          { field: 'anio', title: 'Año' },
          { field: 'umas', title: 'UMAS' }
        ];
        this.obtenerUMAS()
        break;
        
      case 'calendario-pago':
        this.tableHeaders = [
          { field: 'mesContable', title: 'Periodo' },
          { field: 'periodoInicio', title: 'Fecha de Inicio' },
          { field: 'periodoFin', title: 'Fecha de Fin' },
          { field: 'limiteInfoColaborador', title: 'Límite de Información de Colaborador' },
          { field: 'limiteInfoSAP', title: 'Límite de Información de SAP' }
        ];
        this.obtenerCalendarioPago();
        break;
        
      case 'sat':
        this.tableHeaders = [
          { field: 'descripcion', title: 'Descripción' },
          { field: 'codigoInicioClase', title: 'Código Inicio' },
          { field: 'codigoFinClase', title: 'Código Fin' },
          { field: 'categoria', title: 'Categoría' },
          { field: 'esValido', title: 'Estado' },
          { field: 'codigosClase', title: 'Códigos Clase' }
        ];
        this.obtenerCatalogoSAT();
        break;
      default:
        this.tableHeaders = [];
        this.tableData = [];
    }
  }

  getFieldValue(data: any, field: string): any {
    const value = data[field];
    
    if (field === 'umas') {
      return `$${value?.toFixed(2) || '0.00'}`;
    }
    
    if (field === 'fechaInicio' && this.selectedOption === 'calendario-pago') {
      const fechaInicio = new Date(data.fechaInicio);
      const fechaFin = new Date(data.fechaFin);
      return `${fechaInicio.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })} - ${fechaFin.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })}`;
    }
    
    
    if (field === 'limiteInfoColaborador' || field === 'limiteIncidencias' || field === 'limiteInfoSAP') {
      if (value) {
        const [datePart, timePart] = value.split(' ');
        const date = new Date(datePart);
        return `${date.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${timePart}`;
      }
    }
    
    if (field === 'fechaInicio') {
      if (value) {
        const date = new Date(value);
        return date.toLocaleDateString('es-MX', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      }
    }
    
    return value || '-';
  }

  getTableTitle(): string {
    const titles: { [key: string]: string } = {
      'umas': 'UMAS',
      'calendario-pago': 'Calendario de Pago',
      'sat': 'Pre-Fijos SAT'
    };
    
    return titles[this.selectedOption || ''] || '';
  }

  getColumnWidth(field: string): string {
    if (this.selectedOption === 'calendario-pago') {
      switch (field) {
        case 'periodo': return '200px';
        case 'tipo': return '120px';
        case 'mesContable': return '150px';
        case 'fechaInicio': return '200px';
        case 'limiteInfoColaborador': return '200px';
        case 'limiteIncidencias': return '180px';
        case 'limiteInfoSAP': return '200px';
        default: return 'auto';
      }
    }
    return 'auto';
  }

  abrirDrawerEdicion(data: any): void {
    let component: any;
    let title = '';
    
    switch(this.selectedOption) {
      case 'umas':
        component = FormularioUmaComponent;
        title = 'Editar UMAS';
        break;
      case 'calendario-pago':
        component = FormularioCalendarioComponent;
        title = 'Editar Calendario de Pago';
        break;
      case 'sat':
        component = FormularioSatComponent;
        title = 'Editar Concepto SAT';
        break;
      default:
        this.message.error('Tipo de catálogo no válido');
        return;
    }

    const drawerRef = this.drawerService.create({
      nzTitle: title,
      nzContent: component,
      nzWidth: 600,
      nzBodyStyle: { 'padding-bottom': '53px' },
      nzData: {
        data: { ...data },
      }
    });

    drawerRef.afterClose.subscribe((result) => {
      if (result) {
        this.message.success(`${this.getTableTitle().slice(0, -1)} actualizado correctamente`);
        this.loadTableData();
      }
    });
  }

  abrirDrawerNuevoCodigo(catalogoId: number): void {    
    const drawerRef = this.drawerService.create({
      nzTitle: 'Agregar Nuevo Código SAT',
      nzContent: FormularioSatComponent,
      nzWidth: 600,
      nzBodyStyle: { 'padding-bottom': '53px' },
      nzData: {
        data: { catalogoId: catalogoId, isNewCode: true },
      }
    });

    drawerRef.afterClose.subscribe((result) => {
      if (result) {
        this.message.success('Código SAT agregado correctamente');
        this.loadTableData();
      }
    });
  }

  private formatDate(date: Date): string {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  eliminarRegistro(data: any): void {    
    switch(this.selectedOption) {
      case 'umas':
        this.eliminarUMA(data.id);
        break;
      case 'calendario-pago':
        this.eliminarCalendario(data.id);
        break;
      case 'sat':
        this.eliminarConceptoSAT(data.id);
        break;
      default:
        this.message.error('Tipo de catálogo no válido para eliminar');
    }
  }

  private eliminarUMA(id: number): void {
    this.catalogosService.eliminarUMA(id).subscribe({
      next: (res) => {
        if (res.success) {
          this.message.success('UMA eliminado correctamente');
          this.loadTableData();
        } else {
          this.message.error('Error al eliminar UMA');
        }
      },
      error: (err) => {
        console.error('Error al eliminar UMA:', err);
        this.message.error('Error al eliminar UMA');
      }
    });
  }

  private eliminarCalendario(id: number): void {
    this.catalogosService.eliminarCalendario(id).subscribe({
      next: (res) => {
        if (res.success) {
          this.message.success('Calendario eliminado correctamente');
          this.loadTableData();
        } else {
          this.message.error('Error al eliminar calendario');
        }
      },
      error: (err) => {
        console.error('Error al eliminar calendario:', err);
        this.message.error('Error al eliminar calendario');
      }
    });
  }

  private eliminarConceptoSAT(id: number): void {
    this.catalogosService.eliminarConceptoSAT(id).subscribe({
      next: (res) => {
        if (res.success) {
          this.message.success('Concepto SAT eliminado correctamente');
          this.loadTableData();
        } else {
          this.message.error('Error al eliminar concepto SAT');
        }
      },
      error: (err) => {
        console.error('Error al eliminar concepto SAT:', err);
        this.message.error('Error al eliminar concepto SAT');
      }
    });
  }
  obtenerUMAS() {
    this.loading = true;
    this.catalogosService.obtenerCatalogoUMA()
    .pipe(takeUntil(this.$onDestroy), finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    }))
    .subscribe({
      next: (res) => {
        if(res.success){
          this.tableData = res.details as UmasData[] || [];
        }
      },
      error: (err) => {
      }
    });
  }

  obtenerCalendarioPago() {
    this.loading = true;
    this.catalogosService.obtenerCatalogoCalendario()
    .pipe(takeUntil(this.$onDestroy), finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    }))
    .subscribe({
      next: (res) => {
        if(res.success){
          this.tableData = res.details as CalendarioPagoData[] || [];
        }
      },
      error: (err) => {
      }
    });
  }

  obtenerCatalogoSAT() {
    this.loading = true;
    this.catalogosService.obtenerCatalogoSAT()
    .pipe(takeUntil(this.$onDestroy), finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    }))
    .subscribe({
      next: (res) => {
        if(res.success){
          this.tableData = res.details as CatalogoSATData[] || [];
        }
      },
      error: (err) => {
      }
    });
  }

  getCategoryColor(categoria: string): string {
    switch (categoria?.toLowerCase()) {
      case 'medicamentos':
        return 'blue';
      case 'suministros y equipo':
        return 'green';
      case 'servicios médicos':
        return 'purple';
      default:
        return 'default';
    }
  }

  toggleCodigosClase(itemId: number): void {
    if (this.expandedCodigosIds.has(itemId)) {
      this.expandedCodigosIds.delete(itemId);
    } else {
      this.expandedCodigosIds.add(itemId);
    }
  }

  isCodigosExpanded(itemId: number): boolean {
    return this.expandedCodigosIds.has(itemId);
  }

  agregarNuevoCodigo(catalogoId: number): void {
    const catalogoIndex = this.tableData.findIndex(item => item.id === catalogoId);
    if (catalogoIndex === -1) return;

    const nuevoCodigo: CodigoClase = {
      id: Date.now(),
      descripcion: '',
      tipoConcepto: 'EXACTO',
      esValido: true,
      codigoExacto: '',
      codigoInicio: undefined,
      codigoFin: undefined
    };

    if (!this.tableData[catalogoIndex].codigosClase) {
      this.tableData[catalogoIndex].codigosClase = [];
    }

    this.tableData[catalogoIndex].codigosClase.push(nuevoCodigo);
    
    this.editarCodigo(catalogoId, nuevoCodigo);
    
    this.message.info('Nuevo código agregado. Complete los campos.');
  }

  editarCodigo(catalogoId: number, codigo: CodigoClase): void {
    this.editingCodigoKey = `${catalogoId}_${codigo.id}`;
    this.editingCodigoData = { ...codigo };
  }

  isEditingCodigo(catalogoId: number, codigoId: number): boolean {
    return this.editingCodigoKey === `${catalogoId}_${codigoId}`;
  }

  guardarCodigo(catalogoId: number, codigoId: number): void {
    const catalogoIndex = this.tableData.findIndex(item => item.id === catalogoId);
    if (catalogoIndex === -1) return;

    const codigoIndex = this.tableData[catalogoIndex].codigosClase.findIndex((c: CodigoClase) => c.id === codigoId);
    if (codigoIndex === -1) return;

    if (!this.editingCodigoData.descripcion?.trim()) {
      this.message.error('La descripción es requerida');
      return;
    }

    if (this.editingCodigoData.tipoConcepto === 'EXACTO') {
      if (!this.editingCodigoData.codigoExacto?.trim()) {
        this.message.error('El código exacto es requerido para tipo EXACTO');
        return;
      }
      this.editingCodigoData.codigoInicio = undefined;
      this.editingCodigoData.codigoFin = undefined;
    } else if (this.editingCodigoData.tipoConcepto === 'RANGO') {
      if (!this.editingCodigoData.codigoInicio?.trim() || !this.editingCodigoData.codigoFin?.trim()) {
        this.message.error('Los códigos de inicio y fin son requeridos para tipo RANGO');
        return;
      }
      this.editingCodigoData.codigoExacto = undefined;
    }

    this.tableData[catalogoIndex].codigosClase[codigoIndex] = { ...this.editingCodigoData as CodigoClase };
    
    this.editingCodigoKey = null;
    this.editingCodigoData = {};
    
    this.message.success('Código actualizado correctamente');
  }

  cancelarEdicionCodigo(catalogoId: number, codigoId: number): void {
    if (codigoId > 1000000000) {
      this.eliminarCodigo(catalogoId, codigoId);
    }
    
    this.editingCodigoKey = null;
    this.editingCodigoData = {};
  }

  eliminarCodigo(catalogo: any, codigo: any): void {
    this.catalogosService.eliminarConceptoSAT(codigo.id).subscribe({
      next: () => {
        this.message.success('Código eliminado correctamente');
        this.loadTableData();
      },
      error: (err) => {
        this.message.error('Error al eliminar código');
        console.error(err);
      }
    });
  }

  agregarCampo(): void {    
    switch (this.selectedOption) {
      case 'umas':
        this.abrirDrawerAgregar(FormularioUmaComponent, 'Agregar nuevo UMA');
        break;
      case 'calendario-pago':
        this.abrirDrawerAgregar(FormularioCalendarioComponent, 'Agregar nuevo Calendario de Pago');
        break;
      case 'sat':
        this.abrirDrawerAgregar(FormularioSatComponent, 'Agregar nuevo Pre-Fijo SAT');
        break;
      default:
        this.message.info('Función de agregar campo no implementada para esta categoría');
    }
  }

  private abrirDrawerAgregar(component: any, title: string): void {
    const drawer = this.drawerService.create({
      nzTitle: title,
      nzContent: component,
      nzWidth: 612,
      nzContentParams: {
      }
    });

    drawer.afterClose.subscribe(result => {
      if (result) {
        this.message.success(`${this.getTableTitle()} agregado correctamente`);
        this.loadTableData();
      }
    });

  }
}
